import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Toast from '../../../components/ImportDesktopFile/Toast';
import { getFilesToDisplay } from './selectors';
import RoutesUtils from '../../../utils/routes';
import { RoutePath } from '../../../routes/constants';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
	} = state;

	const currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
	const currentOrigin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
	const isFolder = currentRoute === RoutePath.DriveItemListPage && currentOrigin === DriveItemListOrigin.Folder;
	const filesToDisplay = getFilesToDisplay(state);

	return {
		isDisplayed: isFolder && filesToDisplay.length > 0,
	};
};

export default connect(mapStateToProps)(Toast);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/Toast/index.tsx